export default "/build/images/028-1-100x100.png?a977ab9cd275a64e9cffec34fe93e605";